export default {
  header: {
    changeLanguage: 'change language',
    expirationDate: '{0} days before expiration',
    logout: {
      dialog: {
        title: 'Tips',
        content: 'Are you sure you want to log out?',
        positiveText: 'Yes',
        negativeText: 'Cancel',
      },
      logoutSuccess: 'Logging Out Successfully',
    },
    avatar: {
      options: {
        setting: 'Change account settings',
        password: 'Change the password',
        logout: 'Log out',
      },
    },
    notice: {
      message: 'Message',
      readAll: 'Read All',
    },
  },
};
